
































import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class MandatoryQuestionnaireInfoBox extends Vue {
  get questionnaireDownloadLink(): string {
    // JAAS-2803-TODO: Implement questionnaire link for download
    return '';
  }
}
